module.exports = __webpack_public_path__ + "img/other-activities.df16b890.svg";